var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2464)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2092 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2092 2 32.0001 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0791 18.86C17.0791 18.11 17.1991 17.47 17.4391 16.94C17.6791 16.4 18.1091 15.805 18.7291 15.155C19.3391 14.505 19.7591 13.95 19.9891 13.49C20.2291 13.03 20.3491 12.55 20.3491 12.05C20.3491 11.6 20.2741 11.29 20.1241 11.12C19.9841 10.94 19.7741 10.85 19.4941 10.85C18.9241 10.85 18.6391 11.195 18.6391 11.885V13.01H17.0791V11.99C17.0791 11.14 17.2891 10.49 17.7091 10.04C18.1291 9.58 18.7391 9.35 19.5391 9.35C20.3391 9.35 20.9491 9.58 21.3691 10.04C21.7891 10.49 21.9991 11.14 21.9991 11.99C21.9991 12.63 21.8441 13.255 21.5341 13.865C21.2341 14.475 20.7091 15.175 19.9591 15.965C19.4691 16.485 19.1391 16.91 18.9691 17.24C18.7991 17.56 18.7141 17.905 18.7141 18.275V18.5H21.8491V20H17.0791V18.86ZM23.085 18.86C23.085 18.11 23.205 17.47 23.445 16.94C23.685 16.4 24.115 15.805 24.735 15.155C25.345 14.505 25.765 13.95 25.995 13.49C26.235 13.03 26.355 12.55 26.355 12.05C26.355 11.6 26.28 11.29 26.13 11.12C25.99 10.94 25.78 10.85 25.5 10.85C24.93 10.85 24.645 11.195 24.645 11.885V13.01H23.085V11.99C23.085 11.14 23.295 10.49 23.715 10.04C24.135 9.58 24.745 9.35 25.545 9.35C26.345 9.35 26.955 9.58 27.375 10.04C27.795 10.49 28.005 11.14 28.005 11.99C28.005 12.63 27.85 13.255 27.54 13.865C27.24 14.475 26.715 15.175 25.965 15.965C25.475 16.485 25.145 16.91 24.975 17.24C24.805 17.56 24.72 17.905 24.72 18.275V18.5H27.855V20H23.085V18.86Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2464",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.3469b7deb2844da1e2deefcd1c939326.svg";
export { ForwardRef as ReactComponent };